/*
 * Copyright (c) 2020. Sayari LLC
 */

import {Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html'
})
export class AdminComponent implements OnInit {
    apiUrl = environment.apiUrl;
    ngOnInit(): void {
        this.loadScript();
    }

    public loadScript() {
        const body = <HTMLDivElement> document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/js/verify.js';
        script.async = true;
        script.defer = true;
        body.appendChild(script);
        script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/js/fetch_recent_users.js';
        script.async = true;
        script.defer = true;
        body.append(script);
        script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/js/fetch_recent_venues.js';
        script.async = true;
        script.defer = true;
        body.append(script);
    }
}
